import { render, staticRenderFns } from "./PackagesInUnit.vue?vue&type=template&id=cc0cefe6"
import script from "./PackagesInUnit.vue?vue&type=script&lang=js"
export * from "./PackagesInUnit.vue?vue&type=script&lang=js"
import style0 from "./PackagesInUnit.vue?vue&type=style&index=0&id=cc0cefe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports